import { ReactNode } from "react";

export enum NotificationType {
  OnErrorsOrExceptions = 1,
  OnSuccess = 2,
  OnFailure = 3,
  OnProcessCompleted = 4
}

export enum NotificationFailureType {
  IgnoreFileNotFoundError = 1
}

export interface NotificationTypeOption {
  value: NotificationType;
  label: string;
}

export interface AutoImportNotification {
  id: string | number;
  notificationType: NotificationTypeOption;
  typeSettings: NotificationFailureType[];
  to: string;
  cc?: string;
  bcc?: string;
  supportEmail?: string;
  createdBy?: string;
  createdDate?: Date;
  lastModifiedBy?: string;
  lastModifiedDate?: Date;
  isActive?: boolean;
}

export interface GridCellProps {
  dataItem: AutoImportNotification;
}

export interface NotificationColumn {
  field: string;
  title: string;
  width: number;
  cell?: (props: GridCellProps) => ReactNode;
  filterable?: boolean;
}